import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-footer',
  templateUrl: './form-footer.component.html',
  styleUrls: ['./form-footer.component.scss'],
})
export class FormFooterComponent {
  @Input() submitLabel: string = 'Save';
  @Input() cancelLabel: string = 'Cancel';
  @Input() handleCancel: () => void = () => {};
  @Input() handleSubmit: () => void = () => {};
  @Input() formId?: string;
  @Input() small?: boolean = false;
  @Input() disabled?: boolean = false;
  @Input() noCancel?: boolean = false;
  @Input() justifyLeft?: boolean = false;
  @Input() fullWidthButtons?: boolean = false;

  constructor() {}
}
